import React, { useState } from 'react';
import { Tabs, Typography } from 'antd';
import { PictureOutlined, FolderOpenOutlined, LayoutOutlined } from '@ant-design/icons';
import CreativesMedia from './Media/Media';
import CreativesClientMedia from './ClientMedia/ClientMedia';
import CreativesTemplates from './Templates/Templates';

const { Title } = Typography;

const Creatives = () => {
  const [activeTab, setActiveTab] = useState('media');

  const items = [
    {
      key: 'media',
      label: (
        <span>
          <PictureOutlined /> Shared Media Library
        </span>
      ),
      children: <CreativesMedia />
    },
    {
      key: 'client-media',
      label: (
        <span>
          <FolderOpenOutlined /> Client-Specific Media
        </span>
      ),
      children: <CreativesClientMedia />
    },
    {
      key: 'templates',
      label: (
        <span>
          <LayoutOutlined /> Templates & Presets
        </span>
      ),
      children: <CreativesTemplates />
    }
  ];

  return (
    <div style={{ padding: '24px' }}>
      <Title level={2}>Ad Creatives</Title>
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        size="large"
      />
    </div>
  );
};

export default Creatives;
